import { Button, BUTTON_VARIANTS } from 'ui/button';
import { ListSubscribe24, ListUnsubscribe24 } from 'ui/icons/aurora/24px/userEvents';
import { Cell } from '../../../../components/table';
import { TableColumn } from './constants';
import { useModalsContext } from '../../../contexts';
import { ExtendedMessageType } from '../../../types';

type StatusCellProps = {
  messageType: ExtendedMessageType;
};

export const SubscriptionActionCell = ({ messageType }: StatusCellProps) => {
  const { showModal } = useModalsContext();
  const { isSubscribed, isPendingSubscription } = messageType;
  return (
    <Cell columnId={TableColumn.subscriptionAction}>
      {!isPendingSubscription && (
        <Button
          data-test="user-profile-message-type-subscription-action"
          variant={BUTTON_VARIANTS.GHOSTSUCCESS}
          isDisabled={!messageType.isSubscribedToChannel}
          onClick={() => {
            showModal(
              isSubscribed
                ? { unsubscribingFromMessageTypes: [messageType] }
                : { subscribingToMessageTypes: [messageType] },
            );
          }}
        >
          {isSubscribed ? <ListUnsubscribe24 /> : <ListSubscribe24 />}
          {isSubscribed ? 'Unsubscribe' : 'Subscribe'}
        </Button>
      )}
    </Cell>
  );
};
